export default {
  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列
  address: "地址",
  balance: "余额",
  operation: "操作",

  // 操作
  viewDetails: "查看详情",

  // 空状态
  noData: "暂无数据",

  // 下载
  downloadDetails: "下载数据明细",
  downloadFileName: "数据明细",

  // 消息提示
  copySuccess: "复制成功",
};
